import {gql} from '@apollo/client';

export const BCP_CHECK_RESULTS = gql`
    query BcpCheckResults($filters: CheckResultQueryFilterTypeInput, $pageRequest: PageRequestTypeInput) {
        bcpCheckResults(filters: $filters, pageRequest: $pageRequest) {
            success
            code
            message
            content {
                id
                jobId
                jobName
                groupKey
                resultCode
                resultCodeDesc
                status
                statusDesc
                confirmCode
                confirmCodeDesc
                confirmUser
                alarmCount
                createTime
                updateTime
            }
            pageInfo {
                page
                size
                totalElements
                totalPages
                hasNext
                hasPrevious
            }
        }
    }
`;

export const BCP_CHECK_RESULT = gql`
    query BcpCheckResult($id: Long!) {
        bcpCheckResult(id: $id) {
            success
            code
            message
            data {
                id
                jobId
                jobName
                groupKey
                resultCode
                resultCodeDesc
                status
                statusDesc
                data
                confirmCode
                confirmCodeDesc
                confirmDesc
                confirmUser
                confirmTime
                alarmCount
                createTime
                updateTime
            }
        }
    }
`;
